module.exports = __webpack_public_path__ + "static/media/deeptruebexio.5f5a4a54.png";